import React from "react";
import IframeResizer from "iframe-resizer-react";
import HtmlContent from "../../../../../shared/html_content";
import RenderedHtmlContent from "../../../../../shared/virtual_congress/components/rendered_html_content";

export default function NavigationEn2022({...props}) {

   let imageMap = props.imageMap
   let configData = imageMap.config_data

  return <RenderedHtmlContent identifier={"navigation_2022.en"} placeholders={{config: configData, current_image_map_id: imageMap.id}}/>
}